import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-with-large-text-left.component.scss';
var ImageWithLargeTextLeft = /** @class */ (function (_super) {
    tslib_1.__extends(ImageWithLargeTextLeft, _super);
    function ImageWithLargeTextLeft(element) {
        return _super.call(this, element) || this;
    }
    ImageWithLargeTextLeft.prototype.init = function () {
    };
    ImageWithLargeTextLeft.prototype.bindEvents = function () {
    };
    return ImageWithLargeTextLeft;
}(Base));
export { ImageWithLargeTextLeft };



//////////////////
// WEBPACK FOOTER
// ./components/image-with-large-text-left/image-with-large-text-left.component.ts
// module id = 375
// module chunks = 0